import SelectorAdmin from './SelectorAdmin'
import { useFetch } from '../hooks/useFetch'
import { useState, useEffect } from 'react'
import LoadSimple from './LoadSimple'
import Action from './Action'
import { lang } from './generales/traduction'
import { capitalizeFirstLetter, capitalizerTitle } from '../utils/utils'

const NavBar = ({
    languaje, pageSelected, login_state, setServer,
    statusLoginState, setStatusLoginState, msgCharge,
    loadGlobals, dataGlobals, estados_list, server,
    nameState, estadoActivo, setEstadoActivo,
    estadoSelected, setEstadoSelected, dataPingEstado,
    object_state_sessions, set_object_state_sessions,
    statusChangeState, setStatusChangeState
}) => {

    var object_state = ''
    var [aux_user_cassia, set_aux_user_cassia] = useState({ aux_user_cassia: '', aux_pass_cassia: '' })
    const [disabled, setDisabled] = useState(true)
    const [disabled2, setDisabled2] = useState(false)

    const [activeUser, setActiveUser] = useState(() => {
        // Leer sincrónicamente en el init para que esté disponible en el primer render
        try {
            const raw = localStorage.getItem('user_cassia')
            if (!raw) return null
            try { return JSON.parse(raw) }
            catch { return { name: raw } }  // si es string plano, lo envuelve
        } catch { return null }
    })

    const handleChange = (e) => {
        const { name, value } = e.target
        set_aux_user_cassia(prevState => ({ ...prevState, [name]: value }))
    }

    useEffect(() => {
        setDisabled(
            aux_user_cassia.aux_user_cassia === "" || aux_user_cassia.aux_pass_cassia === ""
        )
    }, [aux_user_cassia])

    if (estados_list.data.data !== undefined && dataGlobals != undefined) {
        if (!localStorage.getItem('aux_change_state')) {
            const multi_state = dataGlobals.find(obj => obj.name === 'change_state')
            localStorage.setItem('aux_change_state', multi_state.value)
        }
        const state_id = dataGlobals.find(obj => obj.name === 'state_id')
        object_state = estados_list.data.data.find(obj => obj.id == state_id.value)
        setEstadoActivo(object_state)
        if (Object.values(object_state_sessions).length == 0) {
            if (!localStorage.getItem('object_state_sessions')) {
                set_object_state_sessions((prevObj) => ({
                    ...prevObj,
                    [Object.keys(prevObj).length]: {
                        id: object_state.id, name: object_state.name,
                        server: server.ip, port: server.port,
                        user: 'juan.marcial@seguritech.com', pass: '12345678',
                        access_token: localStorage.getItem('access_token')
                    },
                }))
                localStorage.setItem('object_state_sessions', 1)
            } else {
                set_object_state_sessions(JSON.parse(localStorage.getItem('object_state_sessions')))
                localStorage.setItem('object_state_sessions', 1)
            }
        }
    }

    const manual_login_state = () => {
        localStorage.setItem('aux_user_cassia', aux_user_cassia.aux_user_cassia)
        localStorage.setItem('aux_pass_cassia', aux_user_cassia.aux_pass_cassia)
        setDisabled(true); setDisabled2(true)
        setServer({ ip: localStorage.getItem('aux_server_ip'), port: server.port })
    }

    const accionar_estado = (e) => {
        const object_selected = estados_list.data.data.find(obj => obj.name === e.label)
        setEstadoSelected(object_selected)
    }

    // ── Helpers usuario ──
    const getUserInitial = () => {
        if (!activeUser) return '?'
        const n = activeUser.name || activeUser.username || activeUser.email || ''
        return n.charAt(0).toUpperCase() || '?'
    }
    const getUserName = () => {
        if (!activeUser) return ''
        return activeUser.name || activeUser.username || activeUser.email || ''
    }
    const getUserRole = () => {
        if (!activeUser) return ''
        return activeUser.role || activeUser.rol || activeUser.perfil || ''
    }

    // ── Breadcrumb ──
    // lang devuelve strings como "Monitoreo --> mapa" o "Inicio"
    // Split por " --> " para obtener módulo y submódulo limpios
    const textoOriginal = lang[languaje][pageSelected] || pageSelected || ''
    const [modulo, submodulo] = textoOriginal.split(' --> ').map(t => capitalizeFirstLetter(t.trim()))
    const bcModule = modulo || ''
    const bcSub = submodulo || null

    return (
        <>
            <style>{`
        .nb-loginform input {
          background: #f1f5f9;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          color: #334155;
          font-size: 11px;
          padding: 7px 10px;
          width: 100%;
          outline: none;
          box-sizing: border-box;
          font-family: inherit;
        }
        .nb-loginform input:focus {
          border-color: #1a56db;
          box-shadow: 0 0 0 2px #e8f0fe;
        }
        .nb-userpill:hover { background: #e2e8f0 !important; }
      `}</style>

            <nav style={{
                height: '7%',
                background: '#fff',
                borderBottom: '1px solid #e2e8f0',
                display: 'flex',
                alignItems: 'center',
                padding: '0 18px',
                gap: 10,
                flexShrink: 0,
                fontFamily: "'DM Sans', system-ui, sans-serif",
                position: 'relative',
                zIndex: 10,
                boxShadow: '0 4px 6px -2px rgba(72, 65, 65, 0.56)',
            }}>

                {/* ── LOGO ── */}
                <img
                    src="SaimonTech_logo.png"
                    alt="SaimonTECH"
                    style={{ height: '40px', width: 'auto', objectFit: 'contain', flexShrink: 0 }}
                />

                {/* ── SEPARADOR ── */}
                <div style={{ width: 1, height: 20, background: '#e2e8f0', flexShrink: 0 }} />

                {/* ── BREADCRUMB ── */}
                <div style={{
                    display: 'flex', alignItems: 'center',
                    flex: 1, userSelect: 'none'
                }}>
                    {/* Módulo */}
                    <span style={{
                        fontSize: 12,
                        fontWeight: 400,
                        color: bcSub ? '#94a3b8' : '#334155',
                    }}>
                        {bcModule}
                    </span>

                    {/* Separador + submódulo */}
                    {bcSub && (
                        <>
                            <span style={{
                                fontSize: 14, color: '#d1d5db',
                                margin: '0 7px', fontWeight: 300, lineHeight: 1
                            }}>
                                /
                            </span>
                            <span style={{
                                fontSize: 12,
                                fontWeight: 500,
                                color: '#334155',
                            }}>
                                {bcSub}
                            </span>
                        </>
                    )}
                </div>

                {/* ── ESTADO DE CONEXIÓN (lógica original) ── */}
                {statusChangeState && (
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: 8,
                        background: '#f1f5f9', border: '1px solid #e2e8f0',
                        borderRadius: 6, padding: '4px 10px', flexShrink: 0
                    }}>
                        {dataPingEstado.loading
                            ? <LoadSimple />
                            : (
                                <img
                                    src='/iconos/close.png'
                                    style={{ width: 14, height: 14, cursor: 'pointer', opacity: .5 }}
                                    onClick={() => { setStatusChangeState(false); setStatusLoginState(true) }}
                                />
                            )
                        }
                        <span style={{ fontSize: 10, color: '#64748b' }}>
                            {dataPingEstado.loading
                                ? msgCharge
                                : (dataPingEstado.data != 0 && !dataPingEstado.data?.available)
                                    ? dataPingEstado.error
                                    : msgCharge
                            }
                        </span>
                    </div>
                )}

                {/* ── USUARIO ACTIVO ── */}
                {activeUser && (
                    <div
                        className="nb-userpill"
                        style={{
                            display: 'flex', alignItems: 'center', gap: 7,
                            background: '#f1f5f9', border: '1px solid #e2e8f0',
                            borderRadius: 6, padding: '4px 10px 4px 5px',
                            cursor: 'pointer', transition: 'background .12s',
                            flexShrink: 0
                        }}
                    >
                        <div style={{
                            width: 24, height: 24, borderRadius: '50%',
                            background: '#0f2d5e', color: '#fff',
                            fontSize: 10, fontWeight: 600,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0
                        }}>
                            {getUserInitial()}
                        </div>
                        <div>
                            <div style={{
                                fontSize: 11, fontWeight: 500, color: '#334155',
                                lineHeight: 1.2, whiteSpace: 'nowrap'
                            }}>
                                {getUserName()}
                            </div>
                            {getUserRole() && (
                                <div style={{ fontSize: 9, color: '#94a3b8', whiteSpace: 'nowrap' }}>
                                    {getUserRole()}
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </nav>

            {/* ── FORM LOGIN ESTADO (lógica original) ── */}
            {!statusLoginState && (
                <div style={{
                    position: 'fixed', top: 54, right: 18, zIndex: 100,
                    background: '#fff', border: '1px solid #e2e8f0',
                    borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,.12)',
                    padding: '14px 16px', width: 280,
                    fontFamily: "'DM Sans', system-ui, sans-serif"
                }}>
                    <div style={{
                        display: 'flex', alignItems: 'flex-start', gap: 8,
                        background: '#e8f0fe', border: '1px solid #c3dafe',
                        borderRadius: 7, padding: '8px 10px', marginBottom: 12
                    }}>
                        <svg width="13" height="13" viewBox="0 0 14 14" fill="none"
                            style={{ flexShrink: 0, marginTop: 1 }}>
                            <circle cx="7" cy="7" r="5.5" stroke="#1a56db" strokeWidth="1.2" />
                            <line x1="7" y1="5" x2="7" y2="7.5" stroke="#1a56db"
                                strokeWidth="1.3" strokeLinecap="round" />
                            <circle cx="7" cy="9.2" r=".7" fill="#1a56db" />
                        </svg>
                        <span style={{ fontSize: 10, color: '#334155', lineHeight: 1.5 }}>
                            {capitalizeFirstLetter(lang[languaje]['msgCredencialesEstado'])}
                        </span>
                    </div>
                    <div className="nb-loginform"
                        style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <div>
                            <label style={{
                                fontSize: 9, fontWeight: 600, color: '#64748b',
                                textTransform: 'uppercase', letterSpacing: '.06em',
                                display: 'block', marginBottom: 4
                            }}>
                                {capitalizeFirstLetter(lang[languaje]['correo'])}
                            </label>
                            <input type="text" name='aux_user_cassia'
                                placeholder={capitalizeFirstLetter(lang[languaje]['correo'])}
                                onChange={handleChange} />
                        </div>
                        <div>
                            <label style={{
                                fontSize: 9, fontWeight: 600, color: '#64748b',
                                textTransform: 'uppercase', letterSpacing: '.06em',
                                display: 'block', marginBottom: 4
                            }}>
                                {capitalizeFirstLetter(lang[languaje]['contraseña'])}
                            </label>
                            <input type="password" name='aux_pass_cassia'
                                placeholder="••••••••" onChange={handleChange} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                        <Action origen='General' disabled={disabled}
                            titulo={'Ingresar'} action={manual_login_state} />
                        <Action origen='Alert' disabled={disabled2}
                            titulo={'Cancelar'}
                            action={() => { setStatusLoginState(true); setStatusChangeState(false) }} />
                    </div>
                </div>
            )}
        </>
    )
}

export default NavBar